import React from 'react';
import './Loader.css';

const Loader = ({ label = 'Loading...', fullscreen = false }) => {
  return (
    <div className={`loader ${fullscreen ? 'fullscreen' : ''}`}>
      <div className="loader-ring">
        <span className="loader-dot" />
      </div>
      {label && <p className="loader-label">{label}</p>}
    </div>
  );
};

export default Loader;
